import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { isAdminDomain, redirectToAdmin } from '../../lib/domain';

export function AdminSuperOnlyRoute({ children }: { children: React.ReactNode }) {
  const { user, loading, isSuperAdmin, userRoles, signOut } = useAuth();

  if (loading && (!user || userRoles.length === 0)) {
    return (
      <div className="min-h-dvh flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!isSuperAdmin) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Catches a super admin session that predates this gate (already-open tab,
  // bookmark) — the login/root gates block new sessions, this covers old ones.
  if (!isAdminDomain()) {
    signOut().then(() => redirectToAdmin('/admin/dashboard'));
    return null;
  }

  return <>{children}</>;
}
